import { Component, Input, OnInit } from '@angular/core';
import { MobileProduct, SimInfoResource } from '@dch/products-business-logic';
import {
  ApplicationState,
  getSelectedProductDetails,
  getSimInfo,
  getSimInfoPending,
  getSimInfoTechnicalError,
} from '../../../../store/reducers';
import { filter, map } from 'rxjs/operators';
import { GetSimInfo } from '../../../../store/actions/pricing-plan.actions';
import { getPiiServiceId } from '@dch/ng-usage';
import { OnDestroyHookDirective } from '../../../../shared/hooks';
import { Store } from '@ngrx/store';
import {
  LevelType,
  MessageType,
  PxModalMessageService,
} from '@proximus/ng-common-components';
import { TranslationService } from '@proximus/ng-common';
import { GetProductDetails } from '../../../../store/actions/product-details.actions';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'mprd-sim-and-puk-pxsplus',
  templateUrl: './sim-and-puk-pxsplus.component.html',
})
export class SimAndPukPxsplusComponent
  extends OnDestroyHookDirective
  implements OnInit
{
  @Input() simData: SimInfoResource;
  selectedProduct: MobileProduct;
  isPending = true;
  hasError = false;

  constructor(
    private store: Store<ApplicationState>,
    private pxModalMessageService: PxModalMessageService,
    private translationService: TranslationService,
    private route: ActivatedRoute,
  ) {
    super();
  }

  ngOnInit(): void {
    const serviceId = getPiiServiceId();
    if (serviceId) {
      this.addSubscription(
        this.route.params.subscribe(() => {
          this.store.dispatch(
            new GetProductDetails({
              productType: 'mobile',
              serviceId,
            }),
          );
        }),
      );

      this.addSubscription(
        this.store.select(getSelectedProductDetails).subscribe((product) => {
          if (product && product?.mobileProductDetails) {
            this.selectedProduct = product.mobileProductDetails;
          }
        }),
      );

      this.addSubscription(
        this.store.select(getSimInfoPending).subscribe((isPending) => {
          this.isPending = isPending;
        }),
      );

      this.addSubscription(
        this.store
          .select(getSimInfo)
          .pipe(filter((simInfo) => simInfo !== null))
          .subscribe(
            (simInfo) => {
              this.simData = simInfo;
            },
            () => {
              this.hasError = true;
              if (this.hasError) {
                this.displayErrorModal();
              }
            },
          ),
      );

      this.addSubscription(
        this.store
          .select(getSimInfoTechnicalError)
          .pipe(map((error) => !!error))
          .subscribe((hasError) => {
            this.hasError = hasError;
            if (this.hasError) {
              this.displayErrorModal();
            }
          }),
      );
      this.store.dispatch(new GetSimInfo({ msisdn: getPiiServiceId() }));
    } else {
      this.hasError = true;
      this.displayErrorModal();
    }
  }

  private displayErrorModal() {
    this.pxModalMessageService.dispatchMessage(
      MessageType.Error,
      LevelType.Root,
      this.translationService.getTranslatedValueFor(
        'mobile.pricingPlan.simInfo.error',
      ),
      this.translationService.getTranslatedValueFor('message.error.title'),
      false,
      false,
      'backendError',
    );
  }
}
